export default __webpack_public_path__ + "static/media/branchesdepartments-icon.379db25b.svg";